import { AxiosResponse } from 'axios';
import {
  IReEnrollmentStudentListResponse,
  IReEnrollmentStudentQueryParams,
  IStudentJourneyResponse,
  IStudentJourneyQueryParams,
  IInitialEnrollmentPayload,
  IInitialEnrollmentResponse,
  ICrossCurriculumTransferPayload,
  ICrossCurriculumTransferResponse,
  // UNIFIED TRANSITION IMPORTS (CVA-3257)
  IUnifiedTransitionPayload,
  IUnifiedTransitionResponse,
} from '../../interface/reEnrollment-student.interface';
import api from '../api';

// UNIFIED TRANSITION SERVICE (CVA-3257)
const unifiedTransition = async (
  cycleId: string,
  payload: IUnifiedTransitionPayload,
): Promise<AxiosResponse<IUnifiedTransitionResponse>> => {
  return await api.patch<IUnifiedTransitionResponse>(
    `/re-enrollment/cycles/${cycleId}/enrollment`,
    payload,
  );
};

const enrollInitialStudents = async (
  payload: IInitialEnrollmentPayload,
): Promise<AxiosResponse<IInitialEnrollmentResponse>> => {
  return await api.post<IInitialEnrollmentResponse>(
    '/re-enrollment/students/initial-enroll',
    payload,
  );
};

const fetchReEnrollmentStudents = async (
  cycleId: string,
  params?: IReEnrollmentStudentQueryParams,
): Promise<AxiosResponse<IReEnrollmentStudentListResponse>> => {
  return await api.get<IReEnrollmentStudentListResponse>(
    `/re-enrollment/cycles/${cycleId}/students`,
    {
      params,
    },
  );
};

const fetchStudentJourney = async (
  studentId: string,
  params?: IStudentJourneyQueryParams,
): Promise<AxiosResponse<IStudentJourneyResponse>> => {
  return await api.get<IStudentJourneyResponse>(`/re-enrollment/students/${studentId}/journey`, {
    params,
  });
};

const crossCurriculumTransfer = async (
  payload: ICrossCurriculumTransferPayload,
): Promise<AxiosResponse<ICrossCurriculumTransferResponse>> => {
  return await api.patch<ICrossCurriculumTransferResponse>(
    `/re-enrollment/cross-transfer`,
    payload,
  );
};

export const reEnrollmentStudentService = {
  fetchReEnrollmentStudents,
  fetchStudentJourney,
  enrollInitialStudents,
  crossCurriculumTransfer,
  // UNIFIED TRANSITION SERVICE (CVA-3257)
  unifiedTransition,
};
